import React, { memo } from 'react';
import { ChatWidget } from '@papercups-io/chat-widget';

const Papercups = ({ accountId, baseUrl, localization }) => {
  return (
    <ChatWidget
      requireEmailUpfront
      accountId={accountId}
      baseUrl={baseUrl}
      title={localization.title}
      subtitle={localization.subtitle}
      newMessagePlaceholder={localization.placeholder}
      greeting={localization.greeting}
      popUpInitialMessage={20 * 60 * 1000}
      primaryColor="#191919"
    />
  );
};

export default memo(Papercups, (prevProps, nextProps) => prevProps.localization && nextProps.localization && prevProps.localization.title === nextProps.localization.title);